/**
 * Network protocols used by products sold on shelves.
 */
export enum ProductProtocol {
  ENO = 0,
  BLE = 1,
  ZGP = 2,
}
